function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOk({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 512.001 512.001",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 13.788,
    y: 138.827,
    style: {
      fill: "#CFF09E"
    },
    width: 433.77,
    height: 54.213
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#CFF09E"
    },
    cx: 185.58,
    cy: 304.664,
    r: 39.545
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#507C5C"
    },
    d: "M108.935,278.905c7.615,0,13.788-6.174,13.788-13.788c0-7.613-6.173-13.788-13.788-13.788 c-29.407,0-53.333,23.925-53.333,53.334c0,29.407,23.926,53.333,53.333,53.333c14.771,0,28.503-6.044,38.362-16.253 c9.701,10.011,23.272,16.253,38.28,16.253c29.409,0,53.333-23.926,53.333-53.333c0-29.409-23.926-53.334-53.333-53.334 s-53.332,23.925-53.332,53.334c0,3.148,0.29,6.226,0.815,9.225c-0.131,0.263-0.269,0.521-0.385,0.796 c-4.044,9.56-13.361,15.736-23.739,15.736c-14.203,0-25.758-11.555-25.758-25.758C83.179,290.46,94.733,278.905,108.935,278.905z  M185.579,278.905c14.203,0,25.758,11.555,25.758,25.759c0,14.203-11.555,25.758-25.758,25.758s-25.758-11.555-25.758-25.758 C159.821,290.46,171.375,278.905,185.579,278.905z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#507C5C"
    },
    d: "M461.338,269.022v-130.19c0-7.613-6.174-13.788-13.788-13.788H27.575V94.58H447.55 c7.613,0,13.788-6.174,13.788-13.788s-6.174-13.788-13.788-13.788H13.788C6.173,67.005,0,73.179,0,80.793v310.384 c0,7.613,6.173,13.788,13.788,13.788h328.635c16.841,24.171,44.819,40.032,76.448,40.032c51.352,0,93.131-41.779,93.131-93.132 C512,315.805,491.386,284.49,461.338,269.022z M27.575,152.62h406.188v26.64H27.575V152.62z M281.139,296.619h62.812 c-3.699,5.004-6.899,10.393-9.551,16.089h-53.261c-7.613,0-13.788,6.174-13.788,13.788c0,7.613,6.174,13.788,13.788,13.788h45.346 c-0.474,3.798-0.746,7.658-0.746,11.582c0,8.852,1.267,17.407,3.585,25.525H27.575V206.836h406.188v53.103 c-4.852-0.783-9.824-1.206-14.893-1.206c-15.308,0-29.751,3.738-42.504,10.312h-95.228c-7.613,0-13.788,6.174-13.788,13.788 C267.35,290.445,273.524,296.619,281.139,296.619z M418.869,417.421c-36.148,0-65.557-29.409-65.557-65.557 s29.409-65.557,65.557-65.557s65.556,29.409,65.556,65.557S455.017,417.421,418.869,417.421z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#507C5C"
    },
    d: "M417.311,383.562c-3.399,0-6.801-1.249-9.458-3.758l-18.987-17.909 c-5.54-5.224-5.795-13.95-0.569-19.49c5.224-5.541,13.952-5.794,19.49-0.569l9.349,8.819l22.245-21.779 c5.442-5.328,14.169-5.234,19.498,0.205c5.326,5.441,5.235,14.171-0.205,19.498l-31.713,31.048 C424.281,382.246,420.798,383.562,417.311,383.562z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOk);
export default __webpack_public_path__ + "static/media/ok.13b85f7a9a57b91651242731b96d505b.svg";
export { ForwardRef as ReactComponent };